<template>
  <div id="app">
    <Message/>
    <router-view></router-view>
  </div>
</template>

<script>
import Message from './components/Message.vue';

export default {
    components:{
        Message
    }
}
</script>

<style>
#app {
}
:disabled{
    cursor: not-allowed;
}
</style>
